import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./location_state.js";
//#region src/location_state_helper.ts
var location_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(state) {
	switch (state) {
		case 0: return "Draft";
		case 1: return "Live";
		case 2: return "Bite-Only";
		case 3: return "Churned";
	}
}
//#endregion
export { location_state_helper_exports, name };

//# sourceMappingURL=location_state_helper.js.map